<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="selectField" />

    <!-- 수행평가 대상 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>{{ $t('수행평가 대상') }}</h5>

      <div class="writeGridContainer">
        <div>
          <div>{{ $t('부서(업체)명') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <company-selector v-else v-model="form.inputA_1" :fieldId="form.stdInfo.field_id" :readonly="board.readonly || !form.stdInfo.field_id" @select="onSelectFieldSelector" />
        </div>
        <div>
          <div>{{ $t('피평가자') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input v-else v-model="form.inputA_5" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t('평가일') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_6 }}</p>
          <date-selector v-model="form.inputA_6" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!--    청소(미화)-->
    <table-inspect-column7
      class="mt-28px"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      title="업무 수행 여부"
      v-model="form.inspectList"
      :is-note="true"
      :table-header-title="'업무 수행 여부'"
      :table-header-yes="'Yes'"
      :table-header-no="'No'"
      :table-header-na="'N/A'"
      :table-header-note="'개선요망 사항'"
      :is-show-dialog="true"
      footer="※ (중처법=중대재해처벌 등에 관한 법률. 산안법=산업안전보건법)"
      @update-list-check="updateListCheck"
      @update-note="updateListNote"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="form.photoList.length"
      @add="handleAddPhotoList"
      @remove="handleRemovePhotoList"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
      class="mt-28px"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectColumn7 from "@/components/TableInspectColumn7";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import DateSelector from "@/components/selector/DateSelector";
import FieldSelector from "@/components/selector/FieldSelector";
import CompanySelector from "@/components/selector/CompanySelector.vue";

export default {
  components: {
    CompanySelector,
    FieldSelector,
    DateSelector,
    PhotoUploadGridModule,
    TableInspectColumn7,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [
          { id: 0, fileName: "", fileSize: 0, path: "", thumb: "", input: "", placeholder: "조치 전", check: false },
          { id: 1, fileName: "", fileSize: 0, path: "", thumb: "", input: "", placeholder: "조치 전", check: false },
        ],
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",

        inspectList: [
          {
            col1: 1,
            col2: `산안법시행령
 제15조제1호`,
            label: `안전검사대상 기계·기구 확인 및 검사주기 관리
(대상 : 크레인, 컨베이어, 고소작업대 등 15종)`,
            title: "해당작업과 관련된 기계·기구 도는 설비의 안전·보건 점검 및 이상 유무 확인",
            is_checked: "",
          },
          {
            col1: 2,
            col2: `산안법시행령
 제15조제1호`,
            label: "안전검사대상 기계·기구 안전검사 실시",
            title: "해당작업과 관련된 기계·기구 도는 설비의 안전·보건 점검 및 이상 유무 확인",
            is_checked: "",
          },
          {
            col1: 3,
            col2: `산안법시행령
 제15조제1호`,
            label: "크레인, 굴착기 등 작업 전 작업계획서 작성",
            title: "해당작업과 관련된 기계·기구 도는 설비의 안전·보건 점검 및 이상 유무 확인",
            is_checked: "",
          },
          {
            col1: 4,
            col2: `산안법시행령
 제15 제2호`,
            label: "핸드그라인더 등 해당작업과 관련된 기계·기구의 방호장치 설치 여부, 이상 유무 점검",
            title: "관리감독자에게 소속된 종사자의 작업복·보호구 및 방호장치의 점검과 그 착용·사용에 관한 교육·지도",
            is_checked: "",
          },
          {
            col1: 5,
            col2: `산안법시행령
 제15조제2호`,
            label: "해당작업에 필요한 보호구 파악 후 지급 및 착용 지도",
            title: "관리감독자에게 소속된 종사자의 작업복·보호구 및 방호장치의 점검과 그 착용·사용에 관한 교육·지도",
            is_checked: "",
          },
          {
            col1: 6,
            col2: `산안법시행령
 제15조제2호`,
            label: "보호구지급대장 작성 여부",
            title: "관리감독자에게 소속된 종사자의 작업복·보호구 및 방호장치의 점검과 그 착용·사용에 관한 교육·지도",
            is_checked: "",
          },
          {
            col1: 7,
            col2: `산안법시행령
 제15조제3호`,
            label: "중대/산업재해 발생 시 보고 및 응급조치",
            title: "해당 작업에서 발생한 산업재해에 관한 보고 및 이에 대한 응급조치",
            is_checked: "",
          },
          {
            col1: 8,
            col2: `산안법시행령
 제15조제3호`,
            label: "중대/산업재해 발생 시 재발방지계획서 등 기록 및 보존",
            title: "해당 작업에서 발생한 산업재해에 관한 보고 및 이에 대한 응급조치",
            is_checked: "",
          },
          {
            col1: 9,
            col2: `산안법시행령
 제15조제3호`,
            label: "급박한 위험 대비 매뉴얼 마련 및 조치",
            title: "해당 작업에서 발생한 산업재해에 관한 보고 및 이에 대한 응급조치",
            is_checked: "",
          },
          {
            col1: 10,
            col2: `산안법시행령
 제15조 제4호`,
            label: "주기적인 현장 순회 (정리·정돈 및 통로 확보에 대한 확인·감독)",
            title: "해당 작업의 작업장 정리·정돈 및 통로 확보에 대한 확인·감독",
            is_checked: "",
          },
          {
            col1: 11,
            col2: `산안법시행령
 제15조제4호`,
            label: "비상통로 확보 등에 대한 확인",
            title: "해당 작업의 작업장 정리·정돈 및 통로 확보에 대한 확인·감독",
            is_checked: "",
          },
          {
            col1: 12,
            col2: `산안법시행령
 제15조제5호`,
            label: "중대재해예방실 보고 및 요청사항에 대한 협조",
            title: "안전관리자, 보건관리자, 안전보건관리담당자, 산업보건의의 지도·조언에 대한 협조",
            is_checked: "",
          },
          {
            col1: 13,
            col2: `산안법시행령
 제15조제6호`,
            label: "유해·위험요인의 파악에 대한 참여",
            title: "위험성평가에 관한 업무",
            is_checked: "",
          },
          {
            col1: 14,
            col2: `산안법시행령
 제15조제6호`,
            label: "개선조치의 시행에 대한 참여",
            title: "위험성평가에 관한 업무",
            is_checked: "",
          },
          {
            col1: 15,
            col2: `산안법시행령
 제15조제6호`,
            label: "근로자 의견청취 등 종사자의 참여 여부",
            title: "위험성평가에 관한 업무",
            is_checked: "",
          },
          {
            col1: 16,
            col2: `산안법시행령
 제15조제6호`,
            label: "정기위험성평가결과보고서 작성",
            title: "위험성평가에 관한 업무",
            is_checked: "",
          },
          {
            col1: 17,
            col2: `산안법시행령
 제15조제6호`,
            label: "(건설물의 이전 및 변경, 기계기구의 신규도입 및 변경, 작업방법 변경 등 작업환경 변화로 인한 위험요인의 변경 시) 수시위험성평가 실시 여부",
            title: "위험성평가에 관한 업무",
            is_checked: "",
          },
          {
            col1: 18,
            col2: `산안법시행령
 제15조제6호`,
            label: "위험성평가결과보고서 보고(제출)",
            title: "위험성평가에 관한 업무",
            is_checked: "",
          },
          {
            col1: 19,
            col2: "중처법시행령 제4조",
            label: "해당 작업의 안전보건업무 담당자 지정",
            title: "안전보건관리체계 구축",
            is_checked: "",
          },
          {
            col1: 20,
            col2: "중처법시행령 제4조",
            label: "중대/산업재해 발생 시 보고 및 기록 담당자 지정",
            title: "안전보건관리체계 구축",
            is_checked: "",
          },
          {
            col1: 21,
            col2: "산안법 제164조",
            label: "모든 현장에 산업안전보건법령요지, 안전보건관리규정 게시",
            title: "안전보건관련정보의 고지",
            is_checked: "",
          },
          {
            col1: 22,
            col2: "산안법 제164조",
            label: "보존연한 준수",
            title: "서류의 보존",
            is_checked: "",
          },
          {
            col1: 23,
            col2: `산안법
 제64조, 제66조`,
            label: "위생시설 이용 등 협조",
            title: "도급ㆍ용역ㆍ위탁사업 등",
            is_checked: "",
          },
          {
            col1: 24,
            col2: `산안법
 제64조, 제66조`,
            label: `협의체 구성 및 운영 일지 작성(매월 1회)
※ 도급인과 관계수급인의 산재예방조치 및 의견전달, 시정조치 등`,
            title: "도급ㆍ용역ㆍ위탁사업 등",
            is_checked: "",
          },
          {
            col1: 25,
            col2: `산안법
 제64조, 제66조`,
            label: "작업장 순회점검(주1회)",
            title: "도급ㆍ용역ㆍ위탁사업 등",
            is_checked: "",
          },
          {
            col1: 26,
            col2: `산안법
 제64조, 제66조`,
            label: "합동 안전보건 점검(분기 1회 이상)",
            title: "도급ㆍ용역ㆍ위탁사업 등",
            is_checked: "",
          },
          {
            col1: 27,
            col2: "중처법 제4조",
            label: `안전보건관리체계의 구축 및 이행 조치(반기 1회)
※ 산업안전보건관리비 집행의 적정여부 감독, 위급시 작업의 중지와 대피에 대한 사항, 교육지원 여부 확인`,
            title: "도급ㆍ용역ㆍ위탁사업 등",
            is_checked: "",
          },
          {
            col1: 28,
            col2: "산안법시행령 제53조",
            label: "관계수급인의 유해·위험요인에 대한 안전조치 및 위험성평가 실시",
            title: "도급ㆍ용역ㆍ위탁사업 등",
            is_checked: "",
          },
          {
            col1: 29,
            col2: "산안법 제65조",
            label: "관계수급인이 안전보건에 관한 정보 요청 시 제공",
            title: "도급ㆍ용역ㆍ위탁사업 등",
            is_checked: "",
          },
          {
            col1: 30,
            col2: "산안법 제29조",
            label: "신규 채용시 교육 (누락없이) 실시 여부",
            title: "안전보건교육의 실시",
            is_checked: "",
          },
          {
            col1: 31,
            col2: "산안법 제29조",
            label: "정기안전보건교육 (누락없이) 실시 여부",
            title: "안전보건교육의 실시",
            is_checked: "",
          },
          {
            col1: 32,
            col2: "산안법 제29조",
            label: "관리감독자 직무교육 이수 여부",
            title: "안전보건교육의 실시",
            is_checked: "",
          },
          {
            col1: 33,
            col2: "산안법 제29조",
            label: "작업내용 변경시 교육 실시 여부",
            title: "안전보건교육의 실시",
            is_checked: "",
          },
          {
            col1: 34,
            col2: "산안법 제29조",
            label: "특별안전보건교육 실시 여부",
            title: "안전보건교육의 실시",
            is_checked: "",
          },
          {
            col1: 35,
            col2: "산안법 제2절",
            label: "정기 건강진단 실시",
            title: "종사자의 건강관리",
            is_checked: "",
          },
          {
            col1: 36,
            col2: "산안법 제2절",
            label: "건강진단 사후관리",
            title: "종사자의 건강관리",
            is_checked: "",
          },
          {
            col1: 37,
            col2: "산안법 제114,115조",
            label: "화학물질 취급관리(MSDS, 작업공정별 관리 등)",
            title: "종사자의 위험, 건강장해 방지",
            is_checked: "",
          },
          {
            col1: 38,
            col2: "산안법 제37조",
            label: "안전보건표지 부착",
            title: "종사자의 위험, 건강장해 방지",
            is_checked: "",
          },
          {
            col1: 39,
            col2: "산안법 규칙 제665조",
            label: "중량물 관리(5kg이상)",
            title: "종사자의 위험, 건강장해 방지",
            is_checked: "",
          },
          {
            col1: 40,
            col2: "산안법 규칙 제667조",
            label: "근골격계 유해요인 조사(3년 1회)",
            title: "종사자의 위험, 건강장해 방지",
            is_checked: "",
          },
          {
            col1: 41,
            col2: "산안법 제39조",
            label: "보건조치(원재료, 가스, 채광, 소음, 진동 등)",
            title: "종사자의 위험, 건강장해 방지",
            is_checked: "",
          },
          {
            col1: 42,
            col2: "산안법 제36조",
            label: "지도,점검 및 개선내용 조치",
            title: "작업환경의 점검 및 개선",
            is_checked: "",
          },
          {
            col1: 43,
            col2: "산안법 제36조",
            label: "근로자 의견 청취 및 기타 위험요인 조치",
            title: "작업환경의 점검 및 개선",
            is_checked: "",
          },
          {
            col1: 44,
            col2: "산안법 제128조의2",
            label: "작업환경 개선을 위한 조치(휴게실, 휴게시간 등)",
            title: "작업환경의 점검 및 개선",
            is_checked: "",
          },
          {
            col1: 45,
            col2: "산안법 제125조",
            label: "작업환경 측정",
            title: "작업환경의 점검 및 개선",
            is_checked: "",
          },
        ],
      },
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.field_name = value.field_name;
      this.$emit("selectField", value);
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
    updateListNote(indexRows, text) {
      this.form.inspectList[indexRows].note = text;
    },
    handleAddPhotoList() {
      this.form.photoList.push({ id: 0, fileName: "", fileSize: 0, path: "", thumb: "", input: "", placeholder: "조치 전", check: false });
    },
    handleRemovePhotoList() {
      for (let i = this.form.photoList.length - 1; i >= 0; i--) {
        if (this.form.photoList[i].check) {
          this.form.photoList.splice(i, 1);
        }
      }
    },
    selectField() {
      this.form.inputA_1 = "";
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
